import Text from "@/components/ui/text";
import { UserData } from "@/entities/users/types";
import { useTranslation } from "react-i18next";

interface Props {
  createdByUserData: UserData;
}

const CreatedByUserIndication: React.FC<Props> = ({ createdByUserData }) => {
  const { t } = useTranslation();
  return (
    <Text variant="smBodySecondary">
      {`${t("tasks.drawer.task.createdByUser")} ${createdByUserData?.displayName}`}
    </Text>
  );
};

export default CreatedByUserIndication;
